<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 v-if="settings.title" class="text-6xl font-bold">
        {{ settings.title }}
      </h2>
      <p v-if="settings.description" class="text-grey-darkest mt-3 mx-auto text-lg sm:mt-4">
        {{ settings.description }}
      </p>
    </div>
  </div>

  <div class="static-container">
    <div v-if="availableOffers.length > 0" class="mt-10 grid gap-5 lg:grid-cols-3">
      <offer-article-card v-for="offer in availableOffers"
                          :key="`offer-article-card-${offer.id}`"
                          :offer="offer"
      />
    </div>
    <p v-else class="mt-10">Акции не найдены.</p>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import InjectsSeo from '@/mixins/InjectsSeo'
import OfferArticleCard from '@/components/offers/OfferArticleCard'

export default {
  mixins: [InjectsSeo],

  components: {
    OfferArticleCard,
  },

  metaInfo() {
    return this.getMetaInfoFromSettings(this.offersSeo)
  },

  computed: {
    ...mapGetters({
      settings: 'settings/offersList',
      offersSeo: 'settings/offersSeo',
      offers: 'offers/offers',
    }),

    availableOffers() {
      return this.offers.filter(offer => !!offer.article && !!offer.article.title)
    },
  },
}
</script>
